var BOLD = 'font-weight: bold; font-size: 13px;';
var INFO = 'color: #006600;' + BOLD;
var DEBUG = 'color: #0000ff;' + BOLD;
var WARN = 'color: #ff8000;' + BOLD;
var ERROR = 'color: #ff0000;' + BOLD;

var LEVEL_DEBUG = 0;
var LEVEL_INFO = 1;
var LEVEL_WARN = 2;
var LEVEL_ERROR = 3;
var LEVEL_DISABLED = LEVEL_ERROR;

var COLORS = [DEBUG, INFO, WARN, ERROR, ERROR];
var DESCRIPTIONS = ['debug', 'info', 'warn', 'error', 'disabled'];

/**
 * Simple logger
 */
var Log = function() {
    var widget = this;
    widget.options =  {
        console: false
    };
    widget.report = false;
};

Log.prototype.debug = function(klass) {
    this.log(klass, LEVEL_DEBUG, Array.prototype.slice.call(arguments, 1))
};

Log.prototype.info = function(klass) {
    this.log(klass, LEVEL_INFO, Array.prototype.slice.call(arguments, 1))
};

Log.prototype.warn = function(klass) {
    this.log(klass, LEVEL_WARN, Array.prototype.slice.call(arguments, 1))
};

Log.prototype.error = function(klass) {
    this.log(klass, LEVEL_ERROR, Array.prototype.slice.call(arguments, 1))
};

Log.prototype.log = function(klass, level, message) {
    if (!this.options.console) {
        return;
    }

    if (!message || message.length == 0) {
        message = klass;
        klass = null;
    }

    if (typeof klass !== 'object') {
        if (!(message instanceof Array)) {
            message = [message];
        }
        message.unshift(klass);
        klass = null;
    }

    var color = COLORS[level];
    var klassDescription = '';
    if (klass) {
      klassDescription = '[' + klass + ']';
    }

    if (window.console && window.console.log) {
      window.console.log.apply(console, ['%c[' + DESCRIPTIONS[level] + ']' + klassDescription, color].concat(message));
    }
}

Log.LEVEL_DEBUG = LEVEL_DEBUG;
Log.LEVEL_INFO = LEVEL_INFO;
Log.LEVEL_WARN = LEVEL_WARN;
Log.LEVEL_ERROR = LEVEL_ERROR;

Log.getInstance = function() {
  if (this._instance === undefined) {
    this._instance = new this();
  }
  return this._instance;
};

Log.setOptions = function(options) {
    this.getInstance().options = $.extend({}, this.getInstance().options, options || {});
};

Log.debug = function() {
    this.getInstance().debug.apply(this.getInstance(), arguments);
};
Log.info = function() {
    this.getInstance().info.apply(this.getInstance(), arguments);
};
Log.warn = function() {
    this.getInstance().warn.apply(this.getInstance(), arguments);
};
Log.error = function() {
    this.getInstance().error.apply(this.getInstance(), arguments);
};

module.exports = Log;



// WEBPACK FOOTER //
// ./src/resources/js/log.js